export const STORAGE_KEYS = {
  IS_GRAY_SCHOOL: "school_isgrayscalecrm",
  MARKETER_ID: "marketer_id",
  STAFFER_ID: "staffer_id",
  RE_POSTBE_ID: "re_postbe_id",
  TOKEN: "token",
  COMPANY_ID: "company_id",
  SCHOOL_ID: "school_id",
  POSTBE_CRMLEVEL: "PostbeCrmlevel",
  LANGUAGE: "language",
  SCHOOL_ITEM: "schoolItem",
  OPEN_MENU: "openMenu",
  SLIDER_ACTIVE_INDEX: "sliderActiveIndex",
  STATUS: "status",
};
